<!-- 产品-设备详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div v-show="!show_log" class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form " style="max-width: 800px;">
            <!-- 表单-输入栏-查询类型 {uid: 查询UID, mac: 查询MAC} -->
            <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
              <md-field>
                <md-select v-model="searchForm.searchType" >
                  <md-option value="uid">{{$I18n('search_by_uid')}}</md-option>
                  <md-option value="mac">{{$I18n('search_by_mac')}}</md-option>
                  <!-- <md-option value="token">{{$I18n('search_by_token')}}</md-option> -->
                  <md-option value="pk">{{$I18n('search_by_pk')}}</md-option>
                  <md-option value="batch_id">{{$I18n('search_by_batch_id')}}</md-option>
                  <md-option value="sn">{{$I18n('search_by_sn')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 表单-输入栏-查询参数 (与 searchType 对应) -->
            <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label v-if="searchForm.searchType === 'uid'">UID</label>
                <label v-if="searchForm.searchType === 'mac'">MAC</label>
                <label v-if="searchForm.searchType === 'token'">TOKEN</label>
                <label v-if="searchForm.searchType === 'pk'">PK</label>
                <label v-if="searchForm.searchType === 'batch_id'">{{$I18n('batch_id')}}</label>
                <label v-if="searchForm.searchType === 'sn'">SN</label>
                <md-input v-model="searchForm.searchValue"/>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label>{{$I18n("company")}}</label>
                <md-select v-model="searchForm.comp_id">
                  <md-option value="__ALL__">{{$I18n("all")}}</md-option>
                  <md-option v-for="comp in compData" :key  ="comp.comp_id" :value="comp.comp_id">
                    {{comp.comp_name}}
                  </md-option>
                </md-select>
                <!-- <md-icon v-if="error.company">clear</md-icon> -->
              </md-field>
            </div>
            <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
            <div class="md-layout-item md-size-25 left-layout-item" :style="{'padding-right':0}">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon> {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <div class="md-layout card-form">
            <!-- 表单-按钮- -->
            <div class="md-layout md-layout-item md-size-100 md-xsmall-size-100">
              <!-- 表单-按钮-重新查询 (只在大屏幕中显示) -->
              <!-- <div class="md-layout-item md-size-25" v-if="!$root.state.mobile">
                <md-button class= "left-icon md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
              </div> -->
              <div class="md-layout-item right-layout-item">
                <!-- 导出 -->
                <md-button class="left-icon md-info" @click="form_exportModel">
                  {{$I18n("export")}}
                </md-button>
                <!-- 导出记录 -->
                <md-button class="left-icon md-info" @click="form_iexportTableModel">
                  {{$I18n("dev_export")}}
                </md-button>
                <!-- 导入 -->
                <md-button class="left-icon md-info" @click="form_importModel">
                  {{$I18n("import_and_update")}}
                </md-button>
                <!-- 记录 -->
                <md-button class="left-icon md-info" @click="form_importTableModel">
                  {{$I18n("dev_import")}}
                </md-button>
              </div>
            </div>
          </div>
          <!-- 卡片-主体-内容表格 
            UID
            体系
            所属企业
            MAC
            IP
            所属区域
            版本
            设备状态 {1: 未激活, 2: 已激活}
            首次激活时间
            最近上线时间
           -->
          <md-table v-if="tableData.length > 0">
            <md-table-row>
              <md-table-head :style="{'text-align':'center'}">{{'UID'}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('product_name')}}</md-table-head>
              <!-- <md-table-head :style="{'text-align':'center'}">{{$I18n('ser_sys')}}</md-table-head> -->
              <md-table-head :style="{'text-align':'center'}">{{$I18n('company')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{"SN"}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('device_key')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{"Mac"}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('latest_timestamp')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('created_thing_time')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}"  class="button-box">{{$I18n('operate')}}</md-table-head>
            </md-table-row>
            <md-table-row v-for="item in tableData" :key="item.id" @click="() => showTableInfo(item)" :style="{'cursor':'pointer'}">
              <md-table-cell :style="{'text-align':'center'}" :md-label="'UID'">{{ item.uid }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('product_name')">{{ item.pk_name }}</md-table-cell>
              <!-- <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('ser_sys')">{{ item.sys }}</md-table-cell> -->
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="'SN'">{{ item.sn }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('device_key')">{{ item.key }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="'Mac'">{{ item.mac }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('latest_timestamp')">{{ item.update_date }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('created_time')">{{ item.create_date }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" class="button-box" :md-label="$I18n('created_time')">
                <md-button
                  @click.stop="open_info(item)"
                  class="md-info md-sm"
                   style="width: unset;height: 32px;"
                  >查看日志</md-button
                >
              </md-table-cell>
            </md-table-row>
          </md-table>
          <md-table v-model="tableData" v-else>
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :style="{'text-align':'center'}" :md-label="'UID'">{{ item.uid }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('product_name')">{{ item.pk_name }}</md-table-cell>
              <!-- <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('ser_sys')">{{ item.sys }}</md-table-cell> -->
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="'SN'">{{ item.sn }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('device_key')">{{ item.key }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="'Mac'">{{ item.mac }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('latest_timestamp')">{{ item.update_time }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('created_time')">{{ item.create_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <div v-show="show_log" class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form " style="max-width: 950px;">
            <!-- 表单-输入栏-查询类型 {uid: 查询UID, mac: 查询MAC} -->
            <div class="md-layout-item md-size-40 md-xsmall-size-60 left-layout-item">
              <!-- 表单-日期范围选择-创建时间 -->
              <md-field class="md-theme-default md-has-value">
                <el-date-picker  v-model="log_searchForm.create_time" class="md-date-form-item" align="left" type="datetimerange" range-separator="~" prefixIcon="no" value-format="yyyy-MM-dd HH:mm:ss" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
              </md-field>
            </div>
            <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
            <div class="md-layout-item md-size-60 left-layout-item" :style="{'padding-right':0}">
              <md-button class= "left-icon md-info" @click="searchLog">
                <md-icon>search</md-icon> {{$I18n("search")}}
              </md-button>
              <md-button class= "left-icon md-info" @click="downLog">
                <md-icon>download</md-icon> {{$I18n("dl_log")}}
              </md-button>
              <md-button class= "left-icon md-info" @click="openLogFile">
                {{$I18n("dl_task")}}
              </md-button>
            </div>
          </div>
          <md-button style="position: absolute;right: 20px;top: 24px;" @click="log_uid = ''" class="md-primary md-sm md-info right-button md-just-icon md-round">
            <md-icon>reply</md-icon>
          </md-button>
        </md-card-content>
      </md-card>
      <md-card class="none-bottom">
        <md-card-content>
          <div style="height: 66vh;width: 100%;">
            <div style="text-align:right;">
              <md-button class= "left-icon md-info md-sm md-just-icon" @click="log_prev_page">
                <md-icon class="sp-icon">arrow_back_ios</md-icon>
              </md-button>
              <md-button class= "md-info md-sm md-just-icon" @click="log_next_page">
                <md-icon class="sp-icon-2">arrow_forward_ios</md-icon>
              </md-button>
            </div>
            <div style="overflow-y: auto; flex-grow: 1;max-height: 62vh;">
              <div v-for="log in log_tableData" :key="log.gmt_create" class="log_item">
                <div class="data_time">{{log.id}}  {{log.create_time}}</div>
                <div class="data_value" v-for="key in log.log_keys" :key="log.gmt_create + '-' +key">
                  <span class="data_key" style="margin-left: 2em;">{{key}}:</span>
                  <span>{{log.log_json[key]}}</span>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <template>
      <simple-modal ref="modal" :title="$I18n('import_and_update')" :right="true" @submit="modal_submit">
        <!-- 修改/添加弹窗 -->
        <template slot="body">
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field v-if="item.key ==='file'" :class="{'md-error' : modalData.Error.file}">
              <md-input v-model="modalData.Form.file" @click="modal_file_input" readonly :placeholder="$I18n('click_select_file')"/>
              <md-icon v-if="modalData.Error.file">clear</md-icon>
            </md-field>
          </common-form-item>
          <input :style="{display:'none'}" type="file" ref="inputFile" @change="onChange" />
        </template>
        <!-- 弹窗-底部按钮 -->
        <template slot="footer-btn">
          <md-button :style="{ 'left': '32px', 'position': 'absolute',}" class="md-info"  :download="`${$I18n('frame')}.xlsx`"  href="/files/iot_update.xlsx">
            {{$I18n("frame")}}
          </md-button>
        </template>
      </simple-modal>
      <!-- -->
      <simple-modal ref="device_info" :title="$I18n('devcie_info')" :large="true" :right="true" :submitBtn="true" @submit="api_set_info">
        <template slot="body">
          <div class="md-layout"> 
            <common-form-item 
              v-for="item in form_deviceInfoData" 
              v-model="deviceInfo.Form[item.keys]" 
              :error="deviceInfo.Error[item.keys]" 
              :key="item.keys" v-bind="item"
            />
          </div>
          <div class="md-layout" v-if="deviceInfo.Form.data_info">
            <div class="md-layout md-layout-item md-size-100">
              <label class="md-layout-item md-size-100 md-form-label" style="line-height: 1.5; padding-top: 20px; color: #aaa; font-weight: 400; font-size: 16px; text-align: left"> {{$I18n("attr")}}:</label>
              <div class="md-layout-item md-size-100 md-form-item">
                <pre style="text-align: left; border: 1px solid #dddddd;padding: 0 20px;">{{deviceInfo.Form.data_info}}</pre>
              </div>
            </div>          
          </div>
        </template>
        <template slot="footer-btn">
          <md-button @click="openAttrModal" class="left-icon md-info">{{$I18n("attr_set")}}</md-button>
        </template>
      </simple-modal>
      <simple-modal ref="attr" :title="$I18n('attr_set')" :right="true" :submitBtn="true" @submit="api_set_attr">
        <template slot="body">
          <common-form-item 
            v-for="item in form_attrData" 
            v-model="attrData.Form[item.keys]" 
            :error="attrData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </template>
      </simple-modal>
      <simple-modal ref="import" :title="$I18n('dev_import')" :right="true" :large="true" :submitBtn="false">
        <template slot="body">
          <!-- 弹窗-查询表单 -->
          <div class="md-layout">
            <!-- 选择栏-导入状态 {0: 全部, 1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5: 正在导入}-->
            <div class="md-layout-item md-size-25 left-layout-item">
              <md-field>
                <label>{{$I18n("import_state")}}</label>
                <md-select v-model="modalSearchData.state" :placeholder="$I18n('pls_input_role_id')">
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("has_sync_database")}}</md-option>
                  <md-option :value="2">{{$I18n("has_error_row")}}</md-option>
                  <md-option :value="3">{{$I18n("file_error")}}</md-option>
                  <md-option :value="4">{{$I18n("wait_sync_database")}}</md-option>
                  <md-option :value="5">{{$I18n("is_sync_database")}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 时间选择-导入时间 -->
            <div class="md-layout-item md-size-30 left-layout-item">
              <md-field class="md-theme-default md-has-value">
                <label>{{$I18n("import_time")}}</label>
                <el-date-picker :picker-options="pickerOptions" :start-placeholder="$I18n('start')" :end-placeholder=" $I18n('end')" v-model="modalSearchData.time" class="md-date-form-item" align="left" type="daterange" range-separator="~" value-format="yyyy-MM-dd HH:mm:ss" />
              </md-field>
            </div>
            <!-- 按钮-提交查询 -->
            <div class="md-layout-item left-btn">
              <md-button class= "left-icon md-info" @click="modal_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
          <!-- 弹窗-表格
            ID
            用户ID
            企业名称
            体系
            文件下载链接
            文件处理数据数量详情
            状态 {1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5:正在导入}
            导入时间
            完成时间
           -->
          <md-table v-model="modalTableData" class="center-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="$I18n('import_id')">{{ item.import_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sys')">{{ item.sys }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('import_file')">
                <!-- 有下载地址 -->
                <a v-if="item.file_url" :style='{color:"blue"}' :download="`import-${item.import_id}.xlsx`" :href="item.file_url">
                  {{`import-${item.import_id}.xlsx`}}
                </a>
                <!-- 没有下载链接 -->
                <span v-else>{{$I18n("is_none")}}</span>
              </md-table-cell>
              <!-- 显示样式 : 总数/成功条数(绿色)/失败条数(红色) -->
              <md-table-cell :md-label="`${$I18n('mng_num')}/${$I18n('succ_num')}/${$I18n('fail_num')}`">
                {{item.mng_num}}/
                <span :style='{color:"green"}'>{{item.succ_num}}</span>/
                <span :style='{color:"red"}'>{{item.fail_num}}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('import_state')">
                <span v-if="item.state == 1" :style="{color:'green'}">
                  {{$I18n("has_sync_database")}}
                </span>
                <span v-else-if="item.state == 2" :style="{color:'red'}">
                  {{$I18n("has_error_row")}}
                </span>
                <span v-else-if="item.state == 3" :style="{color:'red'}">
                  {{$I18n("file_error")}}
                </span>
                <span v-else-if="item.state == 4" :style="{color:'red'}">
                  {{$I18n("wait_sync_database")}}
                </span>
                <span v-else-if="item.state == 5" :style="{color:'red'}">
                  {{$I18n("is_sync_database")}}
                </span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('import_date')">{{ item.create_date }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_time')">{{ item.update_date }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
          <!-- 弹窗-翻页 -->
          <table-page :total="import_total" :pageSize="import_pageSize" v-model="import_currentPage"/>
        </template>
      </simple-modal>
      <simple-modal ref="import_export" :title="$I18n('dev_import')" :right="true" :large="true" :submitBtn="false">
        <template slot="body">
          <!-- 弹窗-查询表单 -->
          <div class="md-layout">
            <!-- 选择栏-导入状态 {0: 全部, 1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5: 正在导入}-->
            <div class="md-layout-item md-size-25 left-layout-item">
              <md-field>
                <label>{{$I18n("import_state")}}</label>
                <md-select v-model="modalExportSearchData.state">
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("is_export")}}</md-option>
                  <md-option :value="2">{{$I18n("export_fail")}}</md-option>
                  <md-option :value="3">{{$I18n("export_succ")}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 时间选择-导入时间 -->
            <div class="md-layout-item md-size-40 left-layout-item">
              <md-field class="md-theme-default md-has-value">
                <label>{{$I18n("export_time")}}</label>
                <el-date-picker :picker-options="pickerOptions" :start-placeholder="$I18n('start')" :end-placeholder=" $I18n('end')" v-model="modalExportSearchData.time" class="md-date-form-item" align="left" type="daterange" range-separator="~" value-format="yyyy-MM-dd HH:mm:ss" />
              </md-field>
            </div>
            <!-- 按钮-提交查询 -->
            <div class="md-layout-item left-btn">
              <md-button class= "left-icon md-info" @click="modal_changeSearchExportData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
          <!-- 弹窗-表格
            ID
            用户ID
            企业名称
            体系
            文件下载链接
            文件处理数据数量详情
            状态 {1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5:正在导入}
            导入时间
            完成时间
           -->
          <md-table v-if="modalExportTableData.length > 0" v-model="modalExportTableData" class="left-table">
            <md-table-row>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('import_id')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('company')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('import_file')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('import_state')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('time_period')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('create_time')+ '/' +$I18n('update_date')}}</md-table-head>
            </md-table-row>
            <md-table-row v-for="(item, index) in modalExportTableData" :key="index">
              <md-table-cell>{{ item.id }}</md-table-cell>
              <md-table-cell>{{ item.comp_name ?item.comp_name :$I18n("none") }}</md-table-cell>
              <md-table-cell>
                <!-- 有下载地址 -->
                <a v-if="item.file_url" :style='{color:"blue"}' :download="`import-${item.id}.xlsx`" :href="item.file_url">
                  {{`import-${item.id}.xlsx`}}
                </a>
                <!-- 没有下载链接 -->
                <span v-else>{{$I18n("is_none")}}</span>
              </md-table-cell>
              <md-table-cell>
                <span v-if="item.state == 1" :style="{color:'red'}">
                  {{$I18n("is_export")}}
                </span>
                <span v-else-if="item.state == 2" :style="{color:'red'}">
                  {{$I18n("export_fail")}}
                </span>
                <span v-else-if="item.state == 3" :style="{color:'green'}">
                  {{$I18n("export_succ")}}
                </span>
              </md-table-cell>
              <md-table-cell>{{ item.start_time }}-{{item.end_time}}</md-table-cell>
              <md-table-cell>{{ item.create_time }}/{{ item.update_time }}</md-table-cell>
            </md-table-row>
          </md-table>
          <md-table v-else v-model="modalExportTableData" class="left-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="$I18n('import_id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company')">{{ item.comp_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('import_file')">
                <!-- 有下载地址 -->
                <a v-if="item.file_url" :style='{color:"blue"}' :download="`import-${item.id}.xlsx`" :href="item.file_url">
                  {{`import-${item.id}.xlsx`}}
                </a>
                <!-- 没有下载链接 -->
                <span v-else>{{$I18n("is_none")}}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('import_state')">
              </md-table-cell>
              <md-table-cell :md-label="$I18n('time_period')">{{ item.start_time }}-{{item.end_time}}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_time')+ '/' +$I18n('update_time')">{{ item.update_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
          <table-page :total="import_export_total" :pageSize="import_pageSize" v-model="import_exportCurrentPage"/>
        </template>
      </simple-modal>
      <simple-modal ref="export" :title="$I18n('export')" :right="true" @submit="modal_export_submit">
        <template slot="body">
          <common-form-item 
            v-for="item in form_exportData" 
            v-model="modalExportData.Form[item.keys]" 
            :error="modalExportData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field v-if="item.keys === 'date'">
              <el-date-picker :picker-options="pickerOptions" :start-placeholder="$I18n('start')" :end-placeholder=" $I18n('end')" v-model="modalExportData.Form.time" class="md-date-form-item" align="left" type="daterange" range-separator="~" value-format="yyyy-MM-dd HH:mm:ss" />
            </md-field>
          </common-form-item>
        </template>
      </simple-modal>
      <simple-modal ref="down_log_file" :title="$I18n('dl_log')" @submit="api_get_log">
        <template slot="body">
          <div>
            <!-- 表单-日期范围选择-创建时间 -->
            <md-field class="md-theme-default md-has-value">
              <el-date-picker style="margin-left: 80px;" v-model="dl_log_time" class="md-date-form-item" align="left" type="datetimerange" range-separator="~" prefixIcon="no" value-format="yyyy-MM-dd HH:mm:ss" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
            </md-field>
            <!-- {{$I18n("down_log_in", log_down_time[0], log_down_time[1])}} -->
          </div>
        </template>
      </simple-modal>
      <simple-modal ref="log_file" :title="$I18n('dl_task')" :right="true" :large="true" @submit="api_get_log_file" :submitBtnName="$I18n('refresh')">
        <template slot="body">
          <!-- 弹窗-表格
            Id
            时间范围
            状态
            下载地址
            更新时间
            创建时间 
           -->
          <md-table v-model="modalLogTableData" v-if="modalLogTableData.length > 0">
            <md-table-row>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('import_id')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('time_range')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('state')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('import_file')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('update_date')}}</md-table-head>
              <md-table-head :style="{'text-align':'center'}">{{$I18n('created_thing_time')}}</md-table-head>
            </md-table-row>
            <md-table-row v-for="item in modalLogTableData" :key="item.id">
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('import_id')">{{ item.id }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('time_range')">{{ item.start_time }}-{{ item.end_time }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('import_file')">
                <!-- 有下载地址 -->
                <a v-if="item.file_url" :style='{color:"blue"}' :download="`import-${item.id}.xlsx`" :href="item.file_url">
                  {{`import-${item.id}.txt`}}
                </a>
                <!-- 没有下载链接 -->
                <span v-else>{{$I18n("is_none")}}</span>
              </md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('update_date')">{{ item.update_date }}</md-table-cell>
              <md-table-cell :style="{'text-align':'center'}" :md-label="$I18n('created_thing_time')">{{ item.create_date }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
          <md-table v-model="modalLogTableData" v-else>
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="$I18n('import_id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('time_range')">{{ item.start_time }}-{{item.end_time}}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('import_file')">
                <!-- 有下载地址 -->
                <a v-if="item.file_url" :style='{color:"blue"}' :download="`import-${item.id}.xlsx`" :href="item.file_url">
                  {{`import-${item.id}.xlsx`}}
                </a>
                <!-- 没有下载链接 -->
                <span v-else>{{$I18n("is_none")}}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
          <!-- 弹窗-翻页 -->
          <table-page :total="log_file_total" :pageSize="import_pageSize" v-model="log_file_page"/>
        </template>
      </simple-modal>
    </template>
  </div>
</template>
<script>
  // getInitComp
import { nDaysAgo, nMonthsAgo, timestampToString1000, FormClass, formatJsonForNotes,  } from "@/common/tools.js";
export default {
  data() {
    return {
      dl_log_time: ["", ""],
      modalInitLogTableData: [],
      log_file_page : 1,
      log_file_total: 0,
      log_searchForm:{
        create_time:["", ""],
      },
      log_down_time:["", ""],
      log_searchData:{
        create_time:["", ""],
      },
      log_init_tableData:[],
      log_page:1,
      log_size:5,
      log_uid: "",
      deviceInfo : new FormClass({}),
      pickerOptions: { // 选择时间插件的配置 
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      modalExportData: new FormClass({ // 弹窗-导出xls
        company: this.UserInfo.comp_id,
        time   : [],
        pk     : "",
      }),
      modalSearchData : { // 弹窗-表单-检索数据
        state : 0,
        time : [],
      },
      searchForm : { // 表单-表单数据
        searchType : "uid",
        searchValue: "",
        state : "0",
        comp_id: "__ALL__",
      },
      searchData : { // 表格-检索数据
        mac : "",
        uid : "",
        state: 0,
        comp_id: "__ALL__",
      },
      icon  : "computer", // ICON
      title : this.$I18n("device_info"), // 卡片标题
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      modalTitle : "",  // 弹窗标题
      // 弹窗表单相关
      modalData : new FormClass({
        company : this.UserInfo.comp_id,
        type    : 1,
        key     : "",
        file : {
          init:  "",
          check: "required",
        },
        file_url : "",
      }),
      // 弹窗表格数据
      modalTableInitData : [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,
      import_export_total: 0,
      import_exportCurrentPage : 1,
      modalExportTableInitData:[],
      modalExportSearchData:{
        state: 0,
        time: [],
      },
      modalExportSearchForm:{
        state: 0,
        time: [],
      },
      attrData: new FormClass({
        type: 1,
        key : {
          init : "",
          check: function(val){
            return val == "" || !(/[a-zA-Z]/).test(val[0])
          },
        },
        val : {
          init : "",
          check: function(val, formVal){
            if(formVal.type == 1){ // 字符串
              return val == ""
            } else if(formVal.type == 2){ // 整形
              return isNaN(val) || val == "0" || val == "" || !Number.isInteger(parseFloat(val))
            }
          },
        },
      }),
    };
  },
  mounted : function() {
    this.api_getComp().then(() => {
      // let init_comp = getInitComp(this.compData, this.UserInfo.comp_id);
      // this.searchData.comp_id = init_comp;
      // this.searchForm.comp_id = init_comp;
      // return
    })
    .then(this.api_getPageData);
  },
  watch: {
    dl_log_time:{
      handler(newValue){
        if(!newValue || newValue.length !== 2){
          this.dl_log_time = [nDaysAgo(0) + " 00:00:00", nDaysAgo(0) + " 23:59:59"];
        }
      },
      immediate: true,
      deep: true,
    },
    log_searchForm:{
      handler(newValue){
        if(!newValue.create_time || newValue.create_time.length !== 2){
          this.log_searchForm.create_time = ["", ""]
        }
      },
      immediate: true,
      deep: true,
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    log_page(){
      this.api_getUidLog();
    },
    currentPage() {
      this.api_getPageData();
    },
    import_currentPage(){
      this.api_getXlsxData();
    },
  },
  methods: {
    openAttrModal(){
      this.$refs.attr.open();
      this.attrData.Reset();
    },

    api_set_attr(){
      if(this.attrData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify_2"))
        return
      }
      this.$api.setDevParam({
        type: 2,
        uid: this.deviceInfo.Form.uid,
        params : {
          [this.attrData.Form.key]: this.attrData.Form.type == 1 ?this.attrData.Form.val :parseInt(this.attrData.Form.val),
        },
      })
        .then(this.$Then(() => {
          this.$refs.attr.close();
          this.showTableInfo(this.deviceInfo.Form);
        }))
        .catch(this.$Catch("get_error"))
    },
    api_get_log_file(){
      this.$api.getLogFile({
        uid: this.log_uid,
        page_no  : this.log_file_page,
        page_size: this.import_pageSize,
      })
        .then(this.$Then(res => {
          this.modalInitLogTableData = res.data;
          this.log_file_total = res.count;
        }))
        .catch(this.$Catch("get_error"), () => {
          this.modalInitLogTableData = [];
          this.log_file_total = 0;
        })
    },
    api_get_log(){
      this.$api.getLog({
        uid: this.log_uid,
        gmt_start: (new Date(this.dl_log_time[0]).getTime()/ 1000),
        gmt_end  : (new Date(this.dl_log_time[1]).getTime()/ 1000),
      })
        .then(this.$Then(() => {
          this.$refs.down_log_file.close();
          this.openLogFile();
        }))
        .catch(this.$Catch("get_error"))
    },
    openLogFile(){
      this.log_file_page = 1;
      this.api_get_log_file();
      this.$refs.log_file.open();
    },
    downLog(){
      const today_start = nDaysAgo(0) + " 00:00:00"
      const today_end   = nDaysAgo(0) + " 23:59:59"
      this.dl_log_time = [today_start, today_end]
      this.$refs.down_log_file.open();
    },
    log_prev_page(){
      if(this.log_page > 1){
        this.log_page = this.log_page - 1;
      }
    },
    log_next_page(){
      if(this.log_init_tableData.length === this.log_size){
        this.log_page = this.log_page + 1;
      }
    },
    open_info(item){
      this.log_uid = item.uid;
      this.log_searchForm = {
        create_time: ["", ""],
      }
      this.searchLog();
    },
    searchLog(){
      this.log_searchData = {...this.log_searchForm}
      this.log_page= 1;
      this.api_getUidLog();
    },
    api_getUidLog(){
      this.$api.getIotLog({
        uid      : this.log_uid,
        page_size: this.log_size,
        page_no  : this.log_page,
        gmt_start: new Date(this.log_searchData.create_time[0]).getTime()/1000,
        gmt_end  : new Date(this.log_searchData.create_time[1]).getTime()/1000,
      })
        .then(this.$Then(res => {
          this.log_init_tableData = res.data;
          if(res.data.length === 0 && this.log_page > 1){
            this.log_page = this.log_page - 1;
          }
        }))
        .catch(this.$Catch("get_error"), () => {
          this.log_init_tableData = [];
        })
    },
    showTableInfo(item){
      let newItem = {...item};

      this.$api.queryIotRegDetail_1({uid: item.uid})
        // .then(this.$Then(res => {
        //   newItem = {
        //     ...newItem,
        //     ...res.data,
        //   }
        //   return this.$api.queryIotRegDetail_2({uid: item.uid})
        // }))
        .then(this.$Then(res => {
          newItem = {
            ...newItem,
            ...res.data,
            data: res.data.attr,
          }
          // 区域名称
          let zone_name = this.$I18n("unknow");
          if (newItem.zone){
            zone_name = this.$I18n(newItem.zone);
          }
          if (newItem.province){
            zone_name = `${zone_name}-${newItem.province}`
          }
          if (newItem.city){
            zone_name = `${zone_name}-${newItem.city}`
          }
          let pon_time      = "";
          let poff_time     = "";
          let pduration_time= "";
          if(res.data.state_info){
            newItem = {
              ...newItem,
              ...res.data.state_info,
            }
            if(res.data.state_info.pontime && !isNaN(res.data.state_info.pontime)){
              pon_time = timestampToString1000(res.data.state_info.pontime)
            }
            if(res.data.state_info.pofftime && !isNaN(res.data.state_info.pofftime)){
              poff_time = timestampToString1000(res.data.state_info.pofftime)
            }
            if(res.data.state_info.pduration && !isNaN(res.data.state_info.pduration)){
              let t = res.data.state_info.pduration
              
              let s = t % 60;
              t = (t - s) / 60;

              let m = t % 60;
              t = (t - m) / 60;
              
              let h = t % 24;
              let d = (t - h) / 24;
              pduration_time = `${d>0 ?d+"D " :""}${(d+h>0) ?h+"H " :""}${(d+h+m>0) ?m+"M " :""}${s}S`
            }
          }
          // 状态
          let online_state_name = "";//this.$I18n('unknown')
          switch(newItem.s){
            case "1":
            case 1:
              online_state_name = this.$I18n("dev_state_1");
              break;
            case "2":
            case 2:
            default:
              online_state_name = this.$I18n("dev_state_0");
              break;
          }
          this.$refs.device_info.open();
          this.deviceInfo.Update({
            ...newItem,
            offline_time : newItem.gmt_offline ?timestampToString1000(newItem.gmt_offline) :"",
            online_time  : newItem.gmt_online ?timestampToString1000(newItem.gmt_online) :"",
            active_time  : newItem.gmt_active ?timestampToString1000(newItem.gmt_active) :"",
            pon_time      : pon_time,
            poff_time     : poff_time,
            pduration_time: pduration_time,
            zone_name    : zone_name,
            data_info    : newItem.data ?formatJsonForNotes(newItem.data) :"",
            dev_type_name: this.$I18n(this.$Param.deviceType.getName(newItem.dev_type,"unknow")),
            online_state_name : online_state_name,
          });
        }))
        .catch(this.$Catch(""))
    },
    modal_export_submit(){
      if(!this.modalExportData.Form.time){
        this.$errorMsg(this.$I18n("pls_select_3mon"));
        return
      }
      let start = this.modalExportData.Form.time[0];
      let end   = this.modalExportData.Form.time[1];
      if(!start || !end){
        this.$errorMsg(this.$I18n("pls_select_3mon"));
        return
      }
      if(new Date(start).getTime() < new Date(nMonthsAgo(3, end, true)).getTime()){
        this.$errorMsg(this.$I18n("pls_select_3mon"));
        return
      }
      this.$api.exportDevice({ // api: /iot/uid/export/add
        pk        : this.modalExportData.Form.pk,
        gmt_start : new Date(start).getTime() / 1000,
        gmt_end   : new Date(end.replace("00:00:00","23:59:59")).getTime() / 1000,
        company   : this.modalExportData.Form.company,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.export.close();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    modal_changeSearchData(){ // 弹窗-重新查询弹窗内表格数据
      this.import_currentPage = 1;
      this.api_getXlsxData();
    },
    modal_changeSearchExportData(){
      this.import_exportCurrentPage = 1;
      this.modalExportSearchForm = {...this.modalExportTableForm}
      this.api_getExportXlsxData();
    },
    modal_file_input(){ // 点击上传文件
      this.$refs.inputFile.click()
    },
    onChange ($event) { // (file发生变化)
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) { // 选择文件
      const files = target.files || dataTransfer.files;
      if(files[0].type.includes(".sheet")){
        this.modalData.Form.file = this.getFileName(files, target);
      } else {
        this.$errorMsg(this.$I18n("need_xlsx"))
      }
    },
    getFileName (files, target) { // 获取文件名
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        this.modalData.Form.file_url = "";
        this.$api.uploadFile_PUT({
          file: files[0], 
        })
          .then(this.$Then(res => {
            this.modalData.Form.file_url = res.data.get_url;
          }))
          .catch(this.$Catch(this.$I18n("file_error"), () => {
            this.modalData.Form.file = ""
          }))
        return files[0].name
      }

      return null
    },
    api_getXlsxData (){ // API-提交xls文件数据
      this.$api.getDevListXlsx({
        ...this.modalTableForm,
        page_size: this.import_pageSize,
        page_no: this.import_currentPage,
      })
        .then(this.$Then(resData => {
          this.import_total = resData.count;
          this.modalTableInitData = resData.data.map(i => {
            return {
              ...i,
              import_id: i.id,
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableInitData = [];
          this.import_total = 0;
        }))
    },
    api_getExportXlsxData(){
      this.$api.getExportDevice({
        ...this.modalExportSearchForm,
        page_size: this.import_pageSize,
        page_no: this.import_exportCurrentPage,
      })
        .then(this.$Then(resData => {
          this.modalExportTableInitData = resData.data;
          this.import_export_total = resData.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalExportTableInitData = [];
          this.import_export_total = 0;
        }))
    },
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.queryIotReg({ // api: /iot/uid/reg/query
          ...this.searchData,
          comp_id: this.searchData.comp_id === "__ALL__" ?0  :this.searchData.comp_id,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.total = res.count;
          this.tableInitData = res.data.map(item => {
            if(!item.ver){
              item.ver = "";
            }
            return item;
          })
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    api_getComp (){ // API-获取公司信息
      //获取菜单
      return this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    form_changeSearchData () { // 表单-更改查询条件(并立刻查询)
      this.searchData = {
        mac : this.searchForm.searchType === "mac" ?this.searchForm.searchValue :"",
        uid : this.searchForm.searchType === "uid" ?this.searchForm.searchValue :"",
        token : this.searchForm.searchType === "token" ?this.searchForm.searchValue :"",
        pk : this.searchForm.searchType === "pk" ?this.searchForm.searchValue :"",
        import_id : this.searchForm.searchType === "batch_id" ?this.searchForm.searchValue :"",
        sn : this.searchForm.searchType === "sn" ?this.searchForm.searchValue :"",
        state: parseInt(this.searchForm.state),
        comp_id: this.searchForm.comp_id === "__ALL__" ?"__ALL__" :parseInt(this.searchForm.comp_id),
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
    form_importModel () { // 表单-打开 导入xlsx弹窗
      if (this.compData.length === 0){
        this.$errorMsg(this.$I18n("unknown_error"))
        return;
      }
      this.modalData.Reset();
      this.$refs.modal.open();
    },
    form_exportModel () { // 表单-打开 导出xlsx弹窗
      if (this.compData.length === 0){
        this.$errorMsg(this.$I18n("unknown_error"))
        return;
      }
      this.modalExportData.Reset();
      this.$refs.export.open();
    },
    form_importTableModel () { // 表单-打开导入弹窗
      this.api_getXlsxData();
      this.$refs.import.open();
    },
    form_iexportTableModel () { // 表单-打开导入弹窗
      this.import_exportCurrentPage = 1;
      this.modalExportSearchData = {
        state: 0,
        time: [],
      }
      this.modalExportSearchForm = {...this.modalExportTableForm}
      this.api_getExportXlsxData();
      this.$refs.import_export.open();
    },
    api_set_info(){
      this.$api.setUidInfo(this.deviceInfo.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.api_getPageData();
          this.$refs.device_info.close();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    modal_submit () { // 弹窗-提交表单
      var compItem = this.compData.filter(comp => {
        return comp.comp_id == this.modalData.Form.company;
      })[0]
      if(!compItem){
        this.$errorMsg(this.$I18n("unknown_error"))
        return 
      }
      if(!this.modalData.Form.file_url){
        this.error.file = true;
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return 
      }
      this.$api.uploadDevOrder({ // api: /iot/dev/file/update
          file_url: this.modalData.Form.file_url,
          comp_id : this.modalData.Form.company,
          key     : this.modalData.Form.key,
          type    : this.modalData.Form.type,
          sys     : compItem.sys,
      })
        .then(this.$Then(res => {
          if(res.code == 1014){
            this.$errorMsg(this.$I18n("key_error"));
            return
          }
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.modal.close();
        }), [1014])
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    form_attrData(){
      return [
        {
          label   : this.$I18n("param_type"),
          keys    : "type",
          type    : "radio",
          options : [
            {id:1, name:this.$I18n("str")},
            {id:2, name:this.$I18n("int")},
          ],
        },{
          label   : this.$I18n("param_key"),
          keys    : "key",
          type    : "input",
          check   : true,
        },{
          label   : this.$I18n("param_val"),
          keys    : "val",
          type    : "input",
          check   : true,
        },
      ]
    },
    modalLogTableData(){
      return [...this.modalInitLogTableData].map(i => {
        let state_name = this.$I18n("unknow");
        switch(i.state){
          case 1:
            state_name = this.$I18n("task_state_1");
            break;
          case 2:
            state_name = this.$I18n("task_state_2");
            break;
          case 3:
            state_name = this.$I18n("task_state_3");
            break;
        }
        return {
          ...i,
          state_name,
          start_time : timestampToString1000(i.gmt_start),
          end_time   : timestampToString1000(i.gmt_end),
          create_date: timestampToString1000(i.gmt_create),
          update_date: timestampToString1000(i.gmt_update),
        }
      })
    },
    log_tableData(){
      return [...this.log_init_tableData].map(i => {
        try{
          const logJSON = JSON.parse(i.log);
          return {
            ...i,
            create_time: timestampToString1000(i.gmt_create),
            log_json: logJSON,
            log_keys: Object.keys(logJSON),
          }
        }catch{
           return {
            ...i,
            create_time: timestampToString1000(i.gmt_create),
            log_json: {},
            log_keys: [],
           }
        }
      })
    },
    show_log(){
      return this.log_uid !== "";
    },
    modalTableForm(){ // 弹窗-API提交用弹窗表格检索参数
      return {
        state    : this.modalSearchData.state,
        gmt_start: this.modalSearchData.time && this.modalSearchData.time[0]?parseInt(new Date(this.modalSearchData.time[0]).getTime()/1000) :0,
        gmt_end  : this.modalSearchData.time && this.modalSearchData.time[1]?parseInt(new Date(this.modalSearchData.time[1]).getTime()/1000) :0,
      }
    },
    modalExportTableForm(){ // 弹窗-API提交用弹窗表格检索参数
      if(!this.modalExportSearchData.time){
        return {
          state    : this.modalExportSearchData.state,
          gmt_start: "",
          gmt_end  : "",
        }
      }
      return {
        state    : this.modalExportSearchData.state,
        gmt_start: this.modalExportSearchData.time[0]?(new Date(this.modalExportSearchData.time[0]).getTime() / 1000) :"",
        gmt_end  : this.modalExportSearchData.time[1]?(new Date(this.modalExportSearchData.time[1].replace("00:00:00","23:59:59")).getTime() / 1000) :"",
      }
    },
    modalExportTableData() {
      if (!this.modalExportTableInitData || this.modalExportTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalExportTableInitData.map(item => {
          let company = this.compData.filter(comp => comp.comp_id === item.comp_id);
          let comp_name = ""
          if(company.length > 0){
            comp_name = company[0].comp_name
          }
          return {
            ...item,
            comp_name,
            create_time : timestampToString1000(item.gmt_create),
            update_time : timestampToString1000(item.gmt_update),
            start_time  : timestampToString1000(item.gmt_start).split(" ")[0],
            end_time    : timestampToString1000(item.gmt_end).split(" ")[0],
          }
        })]
      }
    },
    modalTableData () { // 弹窗-表格-表格数据(处理后)
      if (!this.modalTableInitData || this.modalTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalTableInitData]
          // .splice((this.import_currentPage-1) * this.import_pageSize, this.import_pageSize)
          .map(item => {
            // 公司
            let company  = this.$I18n("unknow");
            this.compData.forEach(function(com){
                if(com.comp_id == item.comp_id){
                  company = com.comp_short_name ?com.comp_short_name :com.comp_name;
                }
            })
            // 导入状态
            let import_state = this.$I18n("unknow");
            if(item.state== 1){
              import_state = this.$I18n("has_sync_database");
            }else if(item.state == 4){
              import_state = this.$I18n("wait_sync_database");
            }else if(item.state == 2 ){
              import_state = this.$I18n("has_error_row");
            } else if( item.state == 3){
              import_state = this.$I18n("file_error");
            } else if ( item.state == 5){
              import_state = this.$I18n("is_sync_database")
            }
            // 3个参数(确保是数字)
            item.mng_num =  isNaN(item.mng_num )  ?0 :item.mng_num ;
            item.succ_num = isNaN(item.succ_num ) ?0 :item.succ_num;
            item.fail_num = isNaN(item.fail_num ) ?0 :item.fail_num;
            return {
              company,
              import_state,
              type_name: this.$I18n(this.$Param.imoprtType.getName(item.type ,"unknow")),
              ... item,
              create_date : timestampToString1000(item.gmt_create),
              update_date : timestampToString1000(item.gmt_update),
            }
          })
      }
    },
    tableData(){ // 表格-展示数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 公司
          let company  = this.$I18n("unknow");
          this.compData.forEach(function(com){
              if(com.comp_id == item.comp_id){
                company = com.comp_short_name ?com.comp_short_name :com.comp_name;
              }
          })
          // 状态
          let dev_state = "";//this.$I18n('unknown')
          switch(item.active_state){
            case "1":
            case 1:
              dev_state = this.$I18n("no_active");
              break;
            case "2":
            case 2:
            default:
              dev_state = this.$I18n("is_active");
              break;
          }
          // 区域名称
          let zone_name = this.$I18n("unknow");
          if (item.zone){
            zone_name = this.$I18n(item.zone);
          }
          return {
            update_date : item.gmt_create ?timestampToString1000(item.gmt_update) :"",
            create_date : item.gmt_update ?timestampToString1000(item.gmt_create) :"",
            // online_state_name,
            dev_state,
            company,
            zone_name,
            ... item,
          }
        })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "company",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
        },{
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.$Param.imoprtType.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
        },{
          label   : this.$I18n("select_file"),
          isRequired: true,
          key     : "file",
        },{
          label   : this.$I18n("auth_key"),
          keys    : "key",
          type    : "input",
        }
      ]
    },
    form_deviceInfoData(){
      return [
        {
          label   : "UID",
          keys    : "uid",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : "SN",
          keys    : "sn",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("owned_id"),
          keys    : "owned_id",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : "MAC",
          keys    : "mac",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : "IP",
          keys    : "ip",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("zone"),
          keys    : "zone_name",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("srv_ip"),
          keys    : "sip",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        // },{
        //   label   : this.$I18n("ser_sys"),
        //   keys    : "sys",
        //   type    : "input",
        //   disabled: true,
        //   class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("company"),
          keys    : "company",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("product_name"),
          keys    : "pk_name",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : "PK",
          keys    : "pk",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : "DK",
          keys    : "dk",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("dev_type"),
          keys    : "dev_type_name",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("channel_num"),
          keys    : "ch_num",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("version"),
          keys    : "ver",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("active_state"),
          keys    : "active_state",
          type    : "select",
          options : [
            {id: 1, name: this.$I18n("no_active")},
            {id: 2, name: this.$I18n("is_active")},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("active_time"),
          keys    : "active_time",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("online_status"),
          keys    : "online_state_name",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          // pontime：在线时间
          // pofftime：离线时间
          // pduration：在线时长
          label   : this.$I18n("pontime"),
          keys    : "pon_time",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("pofftime"),
          keys    : "poff_time",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("pduration"),
          keys    : "pduration_time",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-33",
        },
      ]
    },
    form_exportData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "company",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
        },{
          label   : this.$I18n("product_pk"),
          keys    : "pk",
          type    : "input",
          placeholder: this.$I18n('pls_input'),
        },{
          label   : this.$I18n("time_period"),
          keys    : "date",
          required: true,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-icon .sp-icon {
    position: relative;
    left: 4px;
  }
  .sp-icon-2{
    position: relative;
    left: 1px;
  }
  .log_item {
    margin-bottom: 10px;
    padding-bottom:10px;
    color: #888888;
    border-bottom: 1px solid #cccccc;
  }
  .log_item:nth-last-of-type(1){
    border-bottom: 0;
    padding-bottom:0px;
  }
  .log_item .data_time{
    color: #000000;
    font-weight: 600;
    font-size: 16px;
  }
  .log_item .data_key{
    margin-right: 5px;
    font-weight: 600;
  }
  .log_item .data_value:hover {
    background: #dddddd;
  }
  .none-bottom{
    margin-bottom: 0px !important;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
